import { faTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const RankChange = ({ change }: { change: number }) => {
  return change > 0 ? (
    <div className='flex flex-col items-center justify-center'>
      <div className='text-xs text-success-500'>
        <FontAwesomeIcon icon={faTriangle} />
      </div>
      <div className='text-xs text-success-500'>{change}</div>
    </div>
  ) : change < 0 ? (
    <div className='flex flex-col items-center justify-center'>
      <div className='text-xs text-error-500'>
        <FontAwesomeIcon icon={faTriangle} className='rotate-180' />
      </div>
      <div className='text-xs text-error-500'>{change}</div>
    </div>
  ) : null;
};
